import * as yup from 'yup';

const initialValues = {
  password: '',
};

const validationSchema = yup.object().shape({
  password: yup.string().trim().required('Password is required'),
});

export { initialValues, validationSchema };
